/*! JointJS+ v3.5.0 - HTML5 Diagramming Framework

Copyright (c) 2022 client IO

 2022-03-02 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/

export const MAX_PORT_COUNT = 3;
export const FONT_FAMILY = "Inter, Helvetica, Arial, sans-serif";
export const OUT_PORT_HEIGHT = 28;
export const OUT_PORT_WIDTH = 96;
export const OUT_PORT_LABEL = "out";
export const PORT_BORDER_RADIUS = 16;
export const GRID_SIZE = 8;
export const PADDING_S = GRID_SIZE;
export const PADDING_L = GRID_SIZE * 2;
export const ADD_PORT_SIZE = 20;
export const REMOVE_PORT_SIZE = 16;
export const BACKGROUND_COLOR = "#F9F9F9";
export const SECONDARY_BACKGROUND_COLOR = "#FCFCFC";
export const LIGHT_COLOR = "#FFFFFF";
export const DARK_COLOR = "#212121";
export const MAIN_COLOR = "#0057FF";
export const LINE_WIDTH = 2;
export const STENCIL_WIDTH = 200;
export const ZOOM_MAX = 3;
export const ZOOM_MIN = 0.4;
export const ZOOM_STEP = 0.2;

// icons
export const MESSAGE_ICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iYmxhY2siIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiPjxwYXRoIGQ9Ik0yMCAySDRjLTEuMSAwLTEuOTkuOS0xLjk5IDJMMiAyMmw0LTRoMTRjMS4xIDAgMi0uOSAyLTJWNGMwLTEuMS0uOS0yLTItMnptLTIgMTJINnYtMmgxMnYyem0wLTNINlY5aDEydjJ6bTAtM0g2VjZoMTJ2MnoiLz48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PC9zdmc+";
export const USER_INPUT_ICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iYmxhY2siIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNMjEgMy4wMUgzYy0xLjEgMC0yIC45LTIgMlY5aDJWNC45OWgxOHYxNC4wM0gzVjE1SDF2NC4wMWMwIDEuMS45IDEuOTggMiAxLjk4aDE4YzEuMSAwIDItLjg4IDItMS45OHYtMTRjMC0xLjExLS45LTItMi0yek0xMSAxNmw0LTQtNC00djNIMXYyaDEwdjN6Ii8+PC9zdmc+";
export const CONFIRMATION_ICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iYmxhY2siIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNOSAxNi4yTDQuOCAxMmwtMS40IDEuNEw5IDE5IDIxIDdsLTEuNC0xLjRMOSAxNi4yeiIvPjwvc3ZnPg==";
export const ENTITY_ICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9ImJsYWNrIiB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4Ij48Zz48cmVjdCBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB3aWR0aD0iMjQiLz48L2c+PGc+PGcvPjxnPjxwYXRoIGQ9Ik04LDhINnY3YzAsMS4xLDAuOSwyLDIsMmg5di0ySDhWOHoiLz48cGF0aCBkPSJNMjAsM2gtOGMtMS4xLDAtMiwwLjktMiwydjZjMCwxLjEsMC45LDIsMiwyaDhjMS4xLDAsMi0wLjksMi0yVjVDMjIsMy45LDIxLjEsMywyMCwzeiBNMjAsMTFoLThWN2g4VjExeiIvPjxwYXRoIGQ9Ik00LDEySDJ2N2MwLDEuMSwwLjksMiwyLDJoOXYtMkg0VjEyeiIvPjwvZz48L2c+PGcgZGlzcGxheT0ibm9uZSI+PGcgZGlzcGxheT0iaW5saW5lIi8+PGcgZGlzcGxheT0iaW5saW5lIj48cGF0aCBkPSJNOCw4SDZ2N2MwLDEuMSwwLjksMiwyLDJoOXYtMkg4Vjh6Ii8+PHBhdGggZD0iTTIwLDNoLThjLTEuMSwwLTIsMC45LTIsMnY2YzAsMS4xLDAuOSwyLDIsMmg4YzEuMSwwLDItMC45LDItMlY1QzIyLDMuOSwyMS4xLDMsMjAsM3ogTTIwLDExaC04VjdoOFYxMXoiLz48cGF0aCBkPSJNNCwxMkgydjdjMCwxLjEsMC45LDIsMiwyaDl2LTJINFYxMnoiLz48L2c+PC9nPjwvc3ZnPg==";
export const TWITTER_ICON =
  "https://www.pngfind.com/pngs/m/16-169583_png-file-transparent-background-twitter-logo-png-download.png";

export const Icons = {
  general: {
    setVariable: "https://cdn-icons-png.flaticon.com/512/1/1300.png",
    getAttribute: "https://cdn-icons-png.flaticon.com/512/2991/2991112.png",
    getAttributes: "https://cdn-icons-png.flaticon.com/512/3073/3073439.png",
    setAttribute: "https://cdn-icons-png.flaticon.com/512/684/684831.png",
    deleteAttribute: "https://cdn-icons-png.flaticon.com/512/3720/3720456.png",
    runSubflow: "https://cdn-icons-png.flaticon.com/512/4102/4102922.png",
    if: "https://cdn-icons-png.flaticon.com/512/1533/1533440.png",
    start: "https://cdn-icons-png.flaticon.com/512/5375/5375362.png",
  },
  voice: {
    setVoice: "https://cdn-icons-png.flaticon.com/512/4064/4064205.png",
    play: "https://cdn-icons-png.flaticon.com/512/3024/3024584.png",
    menu: "https://cdn-icons-png.flaticon.com/512/151/151917.png",
    forward: "https://cdn-icons-png.flaticon.com/512/3388/3388638.png",
    record: "https://cdn-icons-png.flaticon.com/512/4181/4181205.png",
    makeCall: "https://cdn-icons-png.flaticon.com/512/44/44515.png",
    queue: "https://cdn-icons-png.flaticon.com/512/3298/3298952.png",
    hangup: "https://cdn-icons-png.flaticon.com/512/1285/1285091.png",
  },
  messaging: {
    sendSms: "https://cdn-icons-png.flaticon.com/512/4064/4064205.png",
    sendEmail: "https://cdn-icons-png.flaticon.com/512/482/482138.png",
  },
  tools: {
    runFunction: "https://cdn-icons-png.flaticon.com/512/1774/1774103.png",
    httpRequest: "https://cdn-icons-png.flaticon.com/512/103/103093.png",
    getConfig: "https://cdn-icons-png.flaticon.com/512/103/103091.png",
  },
};

export const ShapeAttributes = {
  width: 48,
  height: 48,
  radius: 24,
  rounded: 6,
  strokeWidth: 2,
  stroke: "grey",
  fill: "whitesmoke",
  circle: {
    cx: 24,
    cy: 24,
    r: 24,
  },
  icon: {
    width: 24,
    height: 24,
    refX: "50%",
    refY: "50%",
    x: -12,
    y: -12,
  },
  port: {
    in: "#d97706",
    out: "#16a34a",
    error: "#ef4444",
  },
};
